<div class="new-button" [title]="title" (click)="onClick.emit()">
    <i class="an an-plus-circle new-button-icon"></i>
</div>